module.exports = __webpack_public_path__ + "img/chat.060a8687.svg";